import { useSelector } from '@/store';
import { StandardAutocompleteIds } from '@features/standardDesign/components/autocomplete/StandardAutocompleteIds';
import { msg } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { type FC } from 'react';
import { useDispatch } from 'react-redux';
import { setParameters } from '../../../slices/devicesAnalysisSlice';

const SidebarComparisonDevices: FC = () => {
  const dispatch = useDispatch();
  const { _ } = useLingui();
  const {
    parameters: { comparisonDeviceIds },
  } = useSelector((state) => state.devices_analysis_store);

  return (
    <StandardAutocompleteIds
      dataType="devices"
      multiple
      label={_(msg`Dispositivos a comparar`)}
      value={comparisonDeviceIds}
      onChange={(_, newIds) => {
        dispatch(
          setParameters({
            comparisonDeviceIds: newIds,
          }),
        );
      }}
      queryOptions={{
        includeGates: true,
      }}
    />
  );
};

export default SidebarComparisonDevices;
